import { supabase } from './supabase';

export interface FlatRateTemplate {
  id: string;
  business_id: string;
  service_id: string;
  title: string;
  hours: number;
  rate_per_hour?: number;
  description?: string;
  status: 'active' | 'inactive';
  created_by?: string;
  created_at: string;
  updated_at: string;
}

export interface CreateFlatRateTemplateParams {
  business_id: string;
  service_id: string;
  title: string;
  hours: number;
  rate_per_hour?: number;
  description?: string;
}

export async function createFlatRateTemplate(params: CreateFlatRateTemplateParams): Promise<FlatRateTemplate> {
  if (!supabase) throw new Error('Supabase client not initialized');
  
  const { data, error } = await supabase
    .from('flat_rate_templates')
    .insert([params])
    .select()
    .single();

  if (error) throw error;
  return data;
}

export async function getFlatRateTemplates(businessId: string): Promise<FlatRateTemplate[]> {
  if (!supabase) throw new Error('Supabase client not initialized');

  const { data, error } = await supabase
    .from('flat_rate_templates')
    .select('*')
    .eq('business_id', businessId)
    .eq('status', 'active')
    .order('created_at', { ascending: false });

  if (error) throw error;
  return data;
}

export async function getFlatRateTemplatesByService(serviceId: string): Promise<FlatRateTemplate[]> {
  if (!supabase) throw new Error('Supabase client not initialized');

  const { data, error } = await supabase
    .from('flat_rate_templates')
    .select('*')
    .eq('service_id', serviceId)
    .eq('status', 'active')
    .order('created_at', { ascending: false });

  if (error) throw error;
  return data;
}

export async function updateFlatRateTemplate(
  id: string,
  updates: Partial<Omit<FlatRateTemplate, 'id' | 'created_at' | 'updated_at'>>
): Promise<FlatRateTemplate> {
  if (!supabase) throw new Error('Supabase client not initialized');

  const { data, error } = await supabase
    .from('flat_rate_templates')
    .update(updates)
    .eq('id', id)
    .select()
    .single();

  if (error) throw error;
  return data;
}

export async function deleteFlatRateTemplate(id: string): Promise<void> {
  if (!supabase) throw new Error('Supabase client not initialized');

  const { error } = await supabase
    .from('flat_rate_templates')
    .delete()
    .eq('id', id);

  if (error) throw error;
} 